import * as React from "react";
import { IInitialState, DataContext, ScreenView } from '../../../models/chat.models';
import { WebChatStartChat } from "../../controls/start-chat/start-chat";
import { WebChatConversation } from "../../controls/conversation/conversation";
import { WebChatSendMessage } from "../../controls/send-message/send-message";
import VoiceChatPage from "../../pages/VoiceChatPage";

export interface WebChatBodyProps { }

export const WebChatContent = (props: WebChatBodyProps) => {
  
  const context: IInitialState = React.useContext(DataContext);

  return (
    <div className="help-desk-content-body">
      <div className="help-desk-conversation help-desk-conversation-wrapper" role="presentation">

      { context.screenView == ScreenView.Welcome && <WebChatStartChat /> }

      { context.screenView == ScreenView.Chat && <WebChatConversation /> }
      { context.screenView == ScreenView.Chat && <WebChatSendMessage /> }

      { context.screenView == ScreenView.VoiceChat && <VoiceChatPage /> }

      </div>
    </div>
  )
}